// Generic
function basic(){
  my_confetti({
  particleCount: 100,
  spread: 70,
  origin: { y: 0.6 }
});
}

function randomDirection(){
 my_confetti({
  angle: randomInRange(55, 125),
  spread: randomInRange(50, 70),
  particleCount: randomInRange(50, 100),
  origin: { y: 0.6 }
}); 
}

function makeItRain() {
  //document.getElementById("makeItRain").disabled = true;
  var end = Date.now() + (10 * 1000);

  // go Buckeyes!
  var colors = ['#bb0000', '#ffffff'];

  function frame() {
    my_confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: colors
    });
    my_confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: colors
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
    else {
      //document.getElementById("makeItRain").disabled = false;
    }
  };

  frame();
}

function randomInRange(min, max) {
  return Math.random() * (max - min) + min;
}

const confetti = require('canvas-confetti');
var myCanvas = document.getElementById('confetti_canvas');
var my_confetti = confetti.create(myCanvas, {
  resize: true,
  useWorker: true
});

//export function play_audio() {
//    if ($("ul#audio-playlist li:first-child").length >= 1) {
//      document.querySelector("audio#"+$("ul#audio-playlist li:first-child")[0].innerText).addEventListener("ended", (event) => {
//        $("ul#audio-playlist li:first-child").remove();
//        play_audio();
//      });
//      document.querySelector("audio#"+$("ul li:first-child")[0].innerText).play();
//    }                
//  }

export function savingscard_effects() {
  var new_stamps = document.getElementById("new_stamps").value;
  if (!!document.getElementById("full-card")) {

    // TODO: make it rain.... (reset)
    makeItRain();

    if(new_stamps == 0 || new_stamps == -1) {
      document.querySelector("audio#"+"audio-effect-fullcard").play();
    } else {
      if(new_stamps == 1) {
        document.querySelector("audio#"+"audio-effect-fullcard-cash").play();
      } else {
        if(new_stamps == 2) {
          document.querySelector("audio#"+"audio-effect-fullcard-cash-cash").play();
        }
      }
    }
  } else {    
    if(new_stamps == 1) {
      document.querySelector("audio#"+"audio-effect-kassa").play();
    } else {
      if(new_stamps == 2) {
        document.querySelector("audio#"+"audio-effect-kassa2").play();
      }
    }
  }
}